import { inject } from '@angular/core';
import { LstUserService } from '@savvaslearning/lst-auth';

import { AuthStore } from '../stores/auth.store';
import { UserStore } from '../stores/user.store';

// lst-auth org roles are 'Student', 'Teacher', 'Pearson Admin' and 'Customer Admin'.
// Only Student (or the legacy `s` code) is a student; the admin roles read as teachers.
function isLstStudentRole(role: string | null | undefined): boolean {
  const normalized = role?.trim().toLowerCase();
  return normalized === 's' || normalized === 'student';
}

// Mirrors the lst-auth user into the identity stores so both backends read the same.
// Call from an injection context.
export function applyLstIdentity(): void {
  const lstUser = inject(LstUserService);
  const authStore = inject(AuthStore);
  const userStore = inject(UserStore);

  // Subscribe, don't read: SSO resolves after bootstrap, so the sync getters are empty here.
  lstUser.userId$.subscribe((userId) => {
    if (userId) authStore.setUserId(userId);
  });

  lstUser.userProfile$.subscribe((profile) => {
    // An empty role means SSO has not resolved yet, so keep whatever the store holds.
    const orgRole = profile?.orgRole?.trim();
    if (orgRole) userStore.setRole(isLstStudentRole(orgRole) ? 'student' : 'teacher');

    const userName = [profile?.firstName, profile?.lastName]
      .map((part) => part?.trim() ?? '')
      .filter((part) => part.length > 0)
      .join(' ');
    if (userName) userStore.setUserName(userName);
  });
}
